// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"41f91d65","744":"87849e97","787":"299a92ab"}[chunkId] + ".chunk.js";
};